
export class IncidentWitnessRemoveCommand {
    varianceId: string;
    witnessId: string;
    constructor(varianceId: string, witnessId: string) {
        this.varianceId = varianceId;
        this.witnessId = witnessId;

    }
}